export default __webpack_public_path__ + "static/media/vision.41a3c046.jpeg";